import { postRequest } from 'utils/api/apiRequest'
import { Image } from 'utils/api/ServiceRequest/postServiceRequest'

export type UploadFileServiceRequest = {
  formData: FormData
}
export const postUploadFile = ({ formData }: UploadFileServiceRequest) =>
  postRequest<UploadFileServiceRequest, { data: Image }>('/cms/service-request/upload', formData)
